import { IonInput, IonItem } from '@ionic/react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { TEST_IDS } from '../../../../config/utils/constants';
import { disableSubmitOnEnter } from '../../../../config/utils/formUtils';
import { isQuantityReceiptFormRelated } from '../../../../services/utils/myDataUtils';
import { useNumericInputDraft } from '../../../../services/utils/useNumericInputDraft';
import { TitleInList } from '../../../atoms/TitleInList';

interface Props {
  fieldName: any;
  formik: any;
  index: number;
}

export const DocProductQuantity = ({ fieldName, formik, index }: Props) => {
  const { t } = useTranslation();
  const formName = `products[${index}][${fieldName}]`;
  const { value, onIonInput } = useNumericInputDraft(formik, formName);
  const isProductsSectionDisabled = useMemo(() => !!formik?.errors?.customerId, [formik?.errors]);
  const hasError = useMemo(
    () => !!(formik.touched && formik?.errors?.products?.[index]?.quantity),
    [formik.touched, formik?.errors],
  );
  const allowNegative = useMemo(
    () => isQuantityReceiptFormRelated(formik?.values?.documentTypeId?.object?.aadeCode),
    [formik?.values?.documentTypeId],
  );

  return (
    <div>
      <TitleInList index={index}>
        <div className="padding-b-16 padding-l-12">{t('SALE.QUANTITY')} *</div>
      </TitleInList>
      <IonItem
        id={`product_${fieldName}_${index}`}
        className={`width-300px height-50px border-radius-input g-select-border cursorPointer ${
          hasError && 'b-field-border-error'
        }`}
        mode="md">
        <IonInput
          id={`${TEST_IDS.Invoice.productQuantityInput}_${index + 1}`}
          className="height-48px"
          disabled={isProductsSectionDisabled}
          mode="md"
          type="number"
          step="0.01"
          min={allowNegative ? undefined : 0.01}
          onKeyPress={disableSubmitOnEnter}
          aria-label="quantity"
          name={formName}
          placeholder={t('SALE.QUANTITY') + '...'}
          onIonInput={onIonInput}
          value={value}
        />
      </IonItem>
    </div>
  );
};
